import { collection, getDocs, query, where } from 'firebase/firestore';
import { useFirestore, useAuth } from '../hooks/useFirebase';
import { ContractType } from '../interfaces/contractType';

export const name = 'readContractCollection';
export const description = 'Reads contracts directly from Firestore, optionally filtered by contractor, customer, and project_number.';
export const parameters = {
  contractor: 'Optional contractor name to filter contracts by.',
  customer: 'Optional customer name to filter contracts by.',
  project_number: 'Optional project number (e.g. "M-22-04") to filter contracts by.'
};
export const outputTextForUI = 'Szerződések lekérése';
export const useOnMobile = true;

export async function readContractCollection(args?: { contractor?: string; customer?: string; project_number?: string }) {
  const db = useFirestore();
  const user = useAuth();

  const filterProjectNumber = args?.project_number;
  const filterContractor = args?.contractor;
  const filterCustomer = args?.customer;

  const constraints: any[] = [where('user_id', '==', user.uid)];

  if (filterProjectNumber) {
    constraints.push(where('project_number', '==', filterProjectNumber));
  }
  if (filterContractor) {
    constraints.push(where('contractor', '==', filterContractor));
  }
  if (filterCustomer) {
    constraints.push(where('customer', '==', filterCustomer));
  }

  const q = query(
    collection(db, 'contract'),
    ...constraints
  );

  const snapshot = await getDocs(q);
  const contractsList: ContractType[] = [];

  snapshot.forEach((doc) => {
    contractsList.push({
      id: doc.id,
      ...doc.data()
    } as ContractType);
  });

  // Sort by created_at or last_modified descending
  contractsList.sort((a, b) => {
    const timeA = a.created_at?.seconds || a.last_modified?.seconds || 0;
    const timeB = b.created_at?.seconds || b.last_modified?.seconds || 0;
    return timeB - timeA;
  });

  // Limit to 50 contracts to keep response clean
  const limitedContracts = contractsList.slice(0, 50);

  return {
    success: true,
    count: limitedContracts.length,
    contracts: limitedContracts
  };
}
